import React, {useState} from "react";

import './_dashboard.scss'

import {Breadcrumb, BreadcrumbItem, Button, Column, Grid, Tile} from "@carbon/react";
import AlarmsTable from "../../components/AlarmsTable";
import ClosedAlarmsTable from "../../components/AlarmsTable/ClosedAlarmsTable";
import {AlarmsOverviewWidget, ShiftOperatorsWidget} from "../../components/DashboardWidgets";
import {Link} from "react-router-dom";
import UnreportedSystemsTable from "../../components/UnreportedSystemsTable";
import moment from "moment/moment";
import PropTypes from "prop-types";
import {CaretDown} from '@carbon/react/icons';

const Dashboard = (props) => {
  const cloudConnected = props.cloudConnected
  const updateRunningRecording = props.updateRunningRecording
  const runningRecording = props.runningRecording
  const [showDetails, setShowDetails] = useState(false)
  const showOtherSections = () => {
    setShowDetails(true)
  }
  return (
    <Grid fullWidth className="dashboard-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                Home
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Dashboard
            </h1>
          </Column>
        </Grid>
        <Grid style={{marginBottom: '2rem'}}>
          <Column lg={16} md={8} sm={4} className="dashboard-page__r3">
            <Tile>
              <AlarmsTable
                cloudConnected={cloudConnected}
                updateRunningRecording={updateRunningRecording}
                runningRecording={runningRecording}/>
            </Tile>
          </Column>
        </Grid>
        {
          showDetails &&
          <Grid>
            <Column lg={13} md={8} sm={4} className="dashboard-page__r4">
              <Tile style={{marginBottom: "2rem"}}>
                <UnreportedSystemsTable DateRef={moment().format("DD/MM/YYYY")}/>
              </Tile>
              <Tile style={{marginBottom: "2rem"}}>
                <ClosedAlarmsTable/>
              </Tile>
            </Column>
            <Column lg={3} md={8} sm={4} className="dashboard-page__r4">
              <Tile style={{marginBottom: "2rem"}}>
                <div className="cds--data-table-header">
                  <h4 className="cds--data-table-header__title">Panoramica allarmi</h4>
                  <p className="cds--data-table-header__description">Conteggio allarmi per priorità</p>
                </div>
                <AlarmsOverviewWidget cloudConnected={cloudConnected}/>
              </Tile>
              <Tile style={{marginBottom: "2rem"}}>
                <div className="cds--data-table-header">
                  <h4 className="cds--data-table-header__title">Operatori di turno</h4>
                  <p className="cds--data-table-header__description">Lista degli operatori di turno</p>
                </div>
                <ShiftOperatorsWidget/>
                <Link className="shifts-manage-link" to="/users/shifts">Gestisci turni</Link>
              </Tile>
            </Column>
          </Grid>
        }
        {
          !showDetails &&
          <Grid>
            <Column lg={16} md={8} sm={4} className="dashboard-page__r4" style={{textAlign: "center"}}>
              <Button kind="secondary" className="cds--table-expand__button" onClick={showOtherSections}
              style={{backgroundColor: "var(--cds-button-secondary-hover, #474747)"}}>
                Carica altre sezioni
                <CaretDown />
              </Button>
            </Column>
          </Grid>
        }
      </Column>
    </Grid>
  )
}

Dashboard.propTypes = {
  cloudConnected: PropTypes.bool.isRequired,
  runningRecording: PropTypes.object,
  updateRunningRecording: PropTypes.func.isRequired,
}

export default Dashboard
